module.exports = __webpack_public_path__ + "media/images/1200/about-648b90ac40c5e72c2b638f2a76ce8e90.webp";